<div *ngIf="show" class="loader-overlay">
  <div class="loader-container d-flex flex-column">
    <img src="/images/view-loader.svg" alt="Q-Mobility Logo" class="loader-image mt-3" />
    <div class="loader-spinner"></div>
  </div>
</div>
